/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
export const es_mx_values = {
  code: "es_mx",
  label: "Español",
};

export const es_mx = {
  1: "#{LABEL}# no puede ser mayor de #{FIELDLENGTH}#",
  3: "#{LABEL}# no concuerda",
  4: "#{LABEL}# no es válido",
  5: "#{LABEL}# es obligatorio",
  6: "#{LABEL}# es muy temprano",
  7: "#{LABEL}# es muy tarde",
  8: "#{LABEL}# debe ser de #{FIELDLENGTH}# caracteres",
  9: "#{LABEL}# debe ser de #{FIELDMAXLENGTH}# caracteres o menos",
  12: "#{LABEL}# debe ser de al menos #{FIELDMIN}#",
  13: "#{LABEL}# debe ser al menos #{FIELDMAX}# caracteres",
  16: "#{LENGTH}#-dígitos",
  17: "#{TITLE}# aún no tiene termostatos inscritos.",
  22: "Un día debe tener al menos un periodo de tiempo.",
  24: "Restricciones de Acceso",
  25: "Restricciones de Acceso guardadas exitosamente.",
  26: "Las Restricciones de Acceso pueden bloquear o limitar funciones y restringir ajustes en su termostato.",
  27: "Cuenta Creada",
  28: "Recuperar Cuenta",
  29: "Activar",
  30: "Código de Activación",
  31: "Añadir Periodo",
  32: "Avanzado",
  33: "Aleta enviada cuando la temperatura está por encima",
  34: "Aleta enviada cuando la temperatura está por debajo",
  35: "Alertas",
  36: "Alertas guardadas exitosamente",
  37: "Todo Alfabéticamente",
  38: "Permitir acceso a todas las funciones en las pantallas de MENU y AJUSTES permite a los usuarios cambiar todo.",
  39: "Permite a los usuarios arrancar un sobremando de tiempo cuando está desocupado o cambiar los puntos de ajuste en su pantalla de INICIO cuando está en ocupado.",
  40: "Se ha producido un error.",
  41: "Error Desconocido",
  43: "Ajustes Aplicación",
  44: "Aplicar",
  45: "¿Aplicar #{LABEL}# a termostatos adicionales?",
  47: "¿Aplicar restricciones de acceso a termostatos adicionales?",
  48: "¿Aplicar ajustes de alerta a termostatos adicionales?",
  49: "Aplicar Cambios A",
  50: "¿Está seguro que desea cambiar su PIN?",
  51: "¿Está seguro que desea borrar todas las notificaciones de alerta?",
  52: "¿Está seguro que desea borrar #{NAME}#?",
  53: "¿Está seguro que desea borrar este Edificio?",
  54: "¿Está seguro que desea borrar este Usuario?",
  55: "¿Está seguro que desea borrar esto?",
  56: "¿Está seguro que desea salir?",
  57: "¿Está seguro que desea remover #{NAME}# del Pivot?",
  59: "Tipo de Autenticación",
  64: "Configuración de Edificio",
  65: "Tablero de Edificio",
  66: "Detalles de Edificio",
  67: "Al acceder a la aplicación Pivot, usted acepta y está de acuerdo a estar obligado por el",
  68: "Llame Soporte al #{PHONENUMBER}#",
  69: "Cancelar",
  70: "No puede crear un nuevo periodo.  Hay un máximo de #{MAXOCCPERIODSPERDAY}# periodos por día.",
  71: "Cambio de #{TITLE}# a #{LABEL}#",
  73: "Cambiando #{MODELABEL}# a #{OPTIONLABEL}#",
  74: "Cambiando #{TITLE}# a #{LABEL}#",
  77: "Remover",
  78: "Remover todo",
  79: "Compresor",
  80: "Velocidad del compresor",
  81: "Confirmar su PIN",
  83: "Continuar",
  87: "Enfriar A",
  88: "Enfriar A: {setpoint}°",
  89: "Enfriar A|{setpoint}. Calentar A|{setpoint}°",
  93: "Crear Grupo",
  94: "Diario",
  95: "Tablero",
  96: "Borrar",
  97: "Borrando",
  98: "Demo - guardar no ocurre",
  99: "Orden Dispositivos",
  100: "Dispositivos",
  102: "Dispositivos primero (por defecto)",
  103: "Deshabilita el acceso a la pantalla de MENU y SISTEMA y MODO DE VENTILADOR pero permite ajustes de temperatura y sobremandos de tiempo.",
  104: "Deshabilita el acceso a la pantalla de MENU pero permite cambios en SISTEMA y MODO DE VENTILADOR así como ajustes de temperatura y sobremandos de tiempo.",
  105: "Desasociar de su Cuenta",
  106: "DESCARTAR",
  107: "Hecho",
  109: "Editar Grupo",
  110: "Correo electrónico",
  111: "Dirección de correo electrónico",
  112: "Dirección de correo no válida",
  113: "Dirección de correo requerida",
  114: "Enviar Correo Soporte",
  115: "Habilitar Contratista de Servicio para ver información acerca de sus Termostatos",
  116: "Inscribir Nuevo Dispositivo",
  117: "Falla al Inscribir.",
  118: "Ingrese su código de activación de 12 dígitos",
  119: "Ingrese su dirección de correo electrónico y le enviaremos un correo para recuperar su nombre de usuario.",
  120: "Ingrese su PIN",
  122: "Ingrese su nombre de usuario y le enviaremos un correo para restablecer su contraseña.",
  123: "Las entradas no concuerdan, por favor ingrese su PIN nuevamente.",
  124: "Eventos",
  125: "Salir Demo",
  126: "Explorar Demo",
  127: "Falla al cambiar #{TITLE}# a #{LABEL}#",
  128: "Falla al cargar el horario activo del termostato.  ¿Usted desea elegir un horario guardado?",
  131: "Por su seguridad no podemos confirmar si su #{PROVIDEDCREDENTIAL}# fue ingresada correctamente. Si no recibe un correo intente nuevamente para asegurarse que su #{PROVIDEDCREDENTIAL}# fue ingresada correctamente. ",
  132: "Olvido su PIN",
  133: "Obtener Código de Activación",
  134: "Obtener Código",
  135: "Volver",
  137: "Grupos primero",
  140: "Calentar A",
  141: "Calentar A |{setpoint}° ",
  142: "Calentar A|#{setpoint}#. Enfriar A|{setpoint}°",
  144: "Ayuda",
  145: "Alto",
  146: "Alerta de Temperatura Ambiente Habilitado",
  147: "Historia",
  148: "Humedad",
  149: "Olvide mi nombre de usuario o contraseña",
  150: "Entiendo los riesgos",
  151: "Si se encuentra listo para añadir un termostato a #{TITLE}# presione el botón de Inscribir Nuevo Dispositivo abajo.",
  152: "Si continuar este usuario no estará habilitado para controlar nada en su cuenta hasta que usted complete el proceso de activación nuevamente.  ¿Está seguro que desea generar un nuevo código de activación para este usuario?",
  153: "Si usted no recibe un correo por favor verifique en su carpeta de correo no deseado y asegúrese que no está bloqueando correos desde #{SUPPORT}#. ",
  154: "PIN no válido.  Por favor intentar nuevamente.",
  156: "El código de acceso del menú principal requiere que las restricciones de acceso se establezcan en Bajo, Medio o Alto.",
  157: "Última Actualización #{TIME}#",
  158: "Información de licencia",
  160: "Cargar",
  162: "Cargando '#{BUILDINGNAME}#'",
  163: "Cargando Registro de Cuenta",
  164: "Cargando Alertas",
  165: "Cargando edificio",
  166: "Cargando historia de tiempo de funcionamiento diario…",
  167: "Cargando horario por defecto",
  168: "Cargando dispositivos…",
  169: "Cargando historia de tiempo de funcionamiento mensual…",
  170: "Cargando Restablecer Contraseña",
  171: "Cargando lista de horarios",
  172: "Cargando Puntos de Ajuste",
  173: "Cargando horario de termostato",
  174: "Cargando…",
  175: "Iniciar sesión",
  176: "Finalizar sesión",
  177: "Iniciar sesión",
  178: "Bajo",
  179: "Administrar usuarios",
  180: "Fabricante",
  181: "Medio",
  184: "Mensual",
  185: "Más",
  186: "Mis Edificios",
  187: "Nombre",
  188: "Nuevo Código de Activación",
  189: "Nuevo Edificio",
  190: "Nuevo Periodo",
  191: "Nuevo Usuario",
  192: "No",
  193: "No hay alertas activas.",
  194: "No hay Autorización",
  196: "No hay Actividad Reciente.",
  197: "Ninguno",
  198: "Por favor selecciones un edificio para habilitar creación de Grupo e inscripción e Dispositivo.",
  200: "Puntos de Ajuste Ocupado",
  201: "Ocupado",
  202: "Tiempo Restante en Ocupado",
  204: "OK",
  206: "Abrir Información Licencia Fuente",
  207: "Operación completa.",
  208: "Versión SO",
  209: "Exterior",
  210: "Contraseña restablecida exitosamente.",
  213: "Entrada de PIN deshabilitada por #{MINUTES}# minutos.",
  214: "Longitud de PIN",
  215: "PIN guardado exitosamente.",
  216: "Versión Aplicación Móvil Pivot",
  217: "Aplicación Móvil Pivot™",
  218: "Plataforma",
  219: "Por favor ingresar un nuevo PIN",
  220: "Favor tenga cuidado cuando remueva la autorización de un usuario de la aplicación.  Debido al riesgo de acceso no autorizado, Pivot recomienda mantener la aplicación bloqueada a no ser que este dispositivo móvil tenga bloqueado de pantalla habilitado.",
  221: "Por favor provea la siguiente información para restablecer su clave.",
  222: "Por favor re-ingrese su usuario y clave para manejar los usuarios de su cuenta de Pivot™.  No tendrá que hacer esto nuevamente.",
  223: "Apuntado a #{HOST}#",
  224: "Código postal",
  225: "Política de Privacidad",
  226: "Recuperar Nombre de Usuario",
  228: "Refrescar Dispositivos",
  229: "Remover #{NAME}# del Pivot",
  230: "Remover Periodo",
  231: "Restablecer contraseña",
  232: "Restablecer PIN",
  233: "Reiniciar la Aplicación",
  234: "Evite el acceso no autorizado al termostato utilizando una contraseña.",
  235: "Restricciones|Nivel de Acceso",
  236: "Restricciones|Código de Acceso",
  237: "Recuperando el historial de tiempo de funcionamiento diario",
  238: "Recuperando el historial de tiempo de funcionamiento mensual",
  239: "Intentar otra vez",
  240: "Historial Tiempo de Funcionamiento",
  241: "Guardar",
  242: "Guardar Como",
  243: "Horarios Guardados",
  244: "Guardando Restricciones de Acceso…",
  245: "Guardando Alertas…",
  246: "Horarios",
  247: "No se pudo habilitar los horarios.  Por favor intente nuevamente más tarde.",
  248: "Horarios habilitados.",
  249: "Los horarios están deshabilitados en este termostato.  ¿Habilitar horarios?",
  250: "SELECCIONAR PÁGINA",
  251: "Enviar sugerencias o realimentación",
  252: "Servicio No Disponible",
  253: "Ajuste un PIN de #{LENGTH}#-dígitos",
  254: "Ajuste un PIN de 8 dígitos",
  255: "Puntos de Ajuste",
  256: "Ajustando enfriamiento a #{SETPOINTCOOL}#",
  257: "Ajustando calefacción a #{SETPOINTHEAT}#",
  258: "Ajustando calefacción a #{SETPOINTHEAT}# y enfriamiento a #{SETPOINTCOOL}#",
  259: "Ajustes",
  260: "Registrarse",
  261: "Regístrese",
  262: "Regístrese Ahora",
  264: "Algo falló mientras se mostraba esta página.",
  266: "Enviar",
  267: "#{NAME}# Inscrito exitosamente",
  268: "Soporte y Realimentación",
  270: "Términos y Condiciones",
  271: "Términos de Uso",
  272: "Gracias.  Debe recibir un correo en breve con #{REQUESTEDEMAIL}#.  El correo puede tardar de 5-10 minutos en llegar.",
  274: "Los siguientes paquetes de fuente abierta son utilizado por la aplicación Móvil de Pivot™.",
  275: "El siguiente periodo está muy cerca del nuevo periodo creado.",
  276: "El periodo anterior está muy cerca al nuevo periodo creado.",
  277: "Tiempo de solicitud agotado.",
  280: "Termostatos",
  281: "La acción no puede ser completada debido a que su cuentea tiene un mínimo de un edificio.",
  282: "Este grupo está vacío.  Edite el grupo para añadir dispositivos.",
  283: "Este dispositivo móvil necesita ser re autenticado.",
  284: "Esta operación no puede ser realizada mientras el dispositivo se encuentra fuera de línea.",
  285: "Este termostato no es compatible con Trane Pivot.",
  286: "Para configurar alertas para un solo termostato haga clic en el ícono de Ajustes -",
  287: "Para inscribir este termostato en #{BUILDINGNAME}# haga clic en Obtener Código para generar un código de 5 dígitos para usted e ingresarlo en el termostato.",
  288: "Para inscribir este termostato bajo un edificio diferente haga clic en Tableros de Edificio seleccione el edificio deseado y luego vuelva a seleccionar el dispositivo en el menú.",
  289: "Para suscribirse o modificar sus alertas suscritas presione el botón Suscripciones de Alertas arriba.",
  291: "Deshacer",
  292: "Des inscribir #{NAME}#",
  294: "Desbloquear Aplicación",
  295: "Desbloquear con biometría",
  296: "Desbloquear con PIN",
  297: "Desbloquear con PIN únicamente",
  298: "Desocupado",
  299: "Utilizar Código de 12 dígitos",
  300: "Nombre de usuario",
  301: "Nombre de usuario y Contraseña",
  302: "Es necesario un nombre de usuario",
  303: "Usuarios",
  304: "Versión",
  305: "No podemos comunicarnos con los servidores de Pivot.  El acceso de internet se requiere para que esta aplicación trabajar apropiadamente.  Por favor verifique sus ajustes de Wi-Fi o datos e intente de nuevo.",
  306: "Bienvenido a Pivot",
  307: "Sí",
  309: "Usted no puede borrar el último periodo de tiempo.",
  310: "Usted no ha guardado aún ningún horario.",
  311: "Su cuenta ha sido creado.  Por favor tome un momento para llenar algunos detalles adicionales.",
  312: "Su red no está disponible.  Verifique sus datos o conexión de Wi-Fi.",
  313: "El nombre del periodo no puede estar vacío.",
  314: "El nombre del periodo no puede contener emojis o caracteres especiales.",
  315: "Alertas de Falla de Termostato Habilitado",
  316: "Guardando Puntos de Ajuste…",
  317: "Puntos de Ajuste guardados exitosamente.",
  318: "Error inesperado",
  319: "¿Aplicar puntos de ajuste a termostatos adicionales?",
  320: "¿Desea utilizar su PIN para desbloquear la aplicación cuando la abra?",
  321: "¿Le gustaría utilizar su #{BIOMETRICSTRING}# para desbloquear su aplicación cuando la abra? Su PIN será utilizado si el #{BIOMETRICSTRING}# falla.",
  322: "Ingrese el nombre de usuario y contraseña de su Pivot para restablecer su PIN",
  323: "Guardando PINs…",
  324: "PINs guardados exitosamente.",
  325: "¿Aplicar PINs a termostatos adicionales?",
  326: "El PIN debe ser de cuatro dígitos numéricos",
  327: "Código de Acceso Menú Principal Habilitado",
  328: "Código de Acceso Menú 4 Dígitos",
  329: "Código de Acceso Técnico Habilitado",
  330: "Código de Acceso Menú Técnicos 4 Dígitos",
  331: "para ese termostato.",
  332: "Nuestro equipo de desarrolladores ha sido notificado acerca del problema y esta trabajando en un arreglo.",
  333: "La página debe ser encontrado.",
  334: "Guardando",
  335: "Diciéndole #{NAME}# a #{ACTION}#",
  336: "Esta acción no puede ser completada porque este edificio contiene dispositivos inscritos.",
  337: "Detalles de Dispositivos",
  338: "El termostato no está actualmente conectado.",
  339: "Términos y condiciones del Acuerdo de licencia de usuario final.",
  340: "¿Esta seguro que desea descartar cualquier cambio al horario?",
  341: "Descartar",
  342: "Debe darle un nombre al horario.",
  343: "Guardar Horarios",
  344: "Guardar horario actual como #{NAME}#",
  345: "Guardar horarios",
  346: "[#{NAME}] ya existe. \n¿Desea remplazarlo?",
  347: "No puede cargar ese horario",
  348: "#{NAME}# no es válido y no puede ser cargado.",
  349: "#{NAME}# no concuerda la escala de temperatura del termostato.",
  350: "Borrando '#{NAME}#'",
  351: "Guardando horario de termostato",
  352: "Guardando horarios…",
  353: "Horario guardado exitosamente.",
  354: "¿Aplicar horarios a termostatos adicionales?",
  355: '"#{NAME}#" Cargado',
  356: "No hay nada allí aún.",
  357: "Nota",
  358: "El modo Demo permite navegar a través de la aplicación del Pivot y explorar como opera.  Cuando utilice la aplicación de Pivot en este modo, cualquier cambio que realice no será guardado.",
  359: "Idioma",
  360: "Ajustar automáticamente a través de este dispositivo",
  361: "Guardando Idioma…",
  362: "Seleccione Idioma",
  363: "Se requiere valor.",
  364: "Editar",
  365: "Horario Activo",
  366: "Código Soporte",
  367: "Versión Chrome",
  368: "Vista Web",
  369: "Desconocido",
  370: "Contraseña",
  371: "Usuario Móvil",
  372: "Código Soporte",
  373: "CALEFACCIÓN",
  374: "ENFRIAMIENTO",
  375: "APAGADO",
  376: "Fecha muy temprana",
  377: "Fecha muy tarde",
  378: "en",
  379: "a las",
  380: "por",
  381: "Evento Dispositivo",
  382: "Evento Horario",
  383: "Navegadores Web",
  384: "Suscripción Alerta",
  385: "Filtro",
  386: "Inscribir #{DEVICE}#",
  387: "Inscribiendo #{DEVICE}#",
  388: "Lun",
  389: "Mar",
  390: "Mie",
  391: "Jue",
  392: "Vie",
  393: "Sáb",
  394: "Ene",
  395: "¿Está seguro de que desea restablecer su contraseña?",
  396: "Aleta enviada cuando la humedad está por encima",
  397: "Aleta enviada cuando la humedad está por debajo",
  398: "Alerta de Humedad Ambiente Habilitado",
  399: "SP_The software included in this product contains copyrighted software that is licensed under the GPL, LGPL or other copyleft license. A copy of those licenses is included herewith.  You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:",
  400: "Trane Commercial HVAC",
  401: "Attn: Open Source Compliance",
  402: "800-E Beaty St.",
  403: "PO Box 940",
  404: "Davidson, NC 28036",
  405: "Please include the name of the product and, if applicable, the version number of the software in the request letter. This offer is valid to anyone in receipt of this information._SP",
  406: "Para transferir su cuenta, ingrese su contraseña",
  407: "Transferir Cuenta",
  409: "Cargando Transferencia de Cuenta",
  410: "¡Hola!",
  411: "Complete los campos a continuación para activar la cuenta Pivot que se le transfirió",
  412: "Alertas de Falla del Termostato",
  413: "Habilitado",
  414: "Deshabilitado",
  415: "Alerta de Temperatura Ambiente",
  416: "Alerta de Humedad Ambiente",
  417: "encima",
  418: "debajo",
  419: "Enviar notificación de alerta en",
  420: "Alerta habilitada",
  421: "Alerta",
  422: "El nombre de usuario está vinculado permanentemente a la cuenta. Cree un nombre de usuario significativo para el propietario.",
  423: "Suscripción de Alerta Usuarios",
  424: "Termostatos que este usuario puede controlar",
  425: "Agregar contacto",
  426: "Recibe alertas seleccionadas en",
  427: "Editar Ajustes",
  428: "Borrar Contacto",
  429: "Suscripciones a alertas de usuario",
  430: "Enviar a",
  431: "al",
  432: "Número de Teléfono",
  433: "Todos",
  434: "Customizado",
  435: "Recibir estas alertas",
  436: "El límite alto y bajo no pueden ser iguales",
  437: "El límite superior debe ser mayor que el límite inferior",
  438: "Mis alertas de notificaciones automáticas",
  439: "este Dispositivo Móvil",
};



// WEBPACK FOOTER //
// ../nx-components/src/Locales/es_mx_core.js